var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5767 11.8666C17.6683 5.69637 20.7218 -0.632948 19.7994 0.0508709C14.0423 10.5944 0.508231 12.2801 0.0152175 16.9873C-0.159723 18.6094 1.20799 22.3625 2.35306 23.5393C2.92559 24.1277 3.8321 24.239 4.53186 23.8096C5.1203 23.4439 5.93139 22.9986 7.01284 22.5374L6.93332 28.485C6.93332 28.8031 7.20368 29.0416 7.52175 28.9939L9.43019 28.7077C9.66875 28.6759 9.85959 28.4691 9.85959 28.2147L9.97092 21.5037C13.8037 20.4382 19.37 19.8021 26.8288 21.2016C28.1965 21.6627 21.2943 17.369 19.5926 11.8507L19.5767 11.8666Z",
    fill: "#716CDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9046 16.8127C24.7138 16.8923 24.5547 16.9559 24.682 17.0354C25.0159 17.258 27.4492 19.8184 28.5307 19.8184C28.6261 19.8184 28.7374 19.8184 28.8328 19.7866C29.0078 19.7548 29.1668 19.5162 29.2463 19.3731C30.121 17.8464 30.1846 13.6958 28.5943 9.0204C26.7017 3.48623 23.6005 0.416992 22.1692 0.416992C22.0897 0.416992 22.0261 0.416999 21.9624 0.448805C21.4058 0.639638 20.4993 2.62749 20.4834 6.58728C20.4834 6.85762 20.722 7.06436 20.9923 7.03255C23.0916 6.90533 24.9682 7.55735 26.1133 9.72012C27.5128 12.36 27.2902 15.795 24.9205 16.7969L24.9046 16.8127Z",
    fill: "#716CDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmi);
export default __webpack_public_path__ + "static/media/smi.65ea01103f958993ed251cc8c7d921ab.svg";
export { ForwardRef as ReactComponent };